import { NewEntityId } from "../../data/constants";
import { ExamStatus, ExamViewModel, RequiredExam, ExamType } from "../../model/Exam";

export const initialExam: ExamViewModel = {
  id: NewEntityId,
  nameDE: "",
  nameEN: "",
  nameFR: "",
  nameIT: "",
  examId: "",
  examExpenses: 0,
  correctionExpenses: 0,
  expertExpenses: 0,
  type: ExamType.Written,
  status: ExamStatus.Draft,
};

export const getInitialRequiredFieldsStatuses = (): RequiredExam => ({
  isNameDEEmpty: false,
  isNameENEmpty: false,
  isNameFREmpty: false,
  isNameITEmpty: false,
});
